import { useFeatureValue } from '@shared/core/featureFlags';

type AccommodationsBaseUrlPayload = {
  url: string;
};

const isValidPayload = (payload: unknown): payload is AccommodationsBaseUrlPayload => {
  if (!payload) {
    return false;
  }

  if (typeof payload !== 'object') {
    return false;
  }

  if (!Object.hasOwn(payload, 'url')) {
    return false;
  }

  const asPayload = payload as AccommodationsBaseUrlPayload;

  if (!asPayload.url.startsWith('https://')) {
    return false;
  }

  return true;
};

/**
 * Uses URL from feature flag, or fallback URL if feature flag content invalid.
 * See https://withjoy.atlassian.net/browse/PRNT-2207
 * @param fallback URL to use in case feature flag data is invalid.
 * @returns URL for Joy Accommodations page
 */
export const useGetAccommodationsBaseUrl = (fallback: string) => {
  const { value, payload } = useFeatureValue('messagingPostRsvpHotelSearchUrl');
  const enabled = value === 'on';
  const valid = isValidPayload(payload);

  if (enabled && valid) {
    return payload.url;
  }

  return fallback;
};
